import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home.tsx'
import Contact from './pages/Contact.tsx'
import FAQ from './pages/FAQ.tsx'
import Header from './components/Header.tsx'
import Footer from './components/Footer.tsx'

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="content-container flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App